import { Box, Button, CircularProgress, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import TableHeader from '../../common/TableHeader'
import { useParams, useSearchParams } from 'react-router-dom'
import api from '../../../service/api'
import { formatDate, Icons } from '../../../utils/utilities'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import errorImg from '../../../assets/request-error.svg'
import noMaterialsImg from '../../../assets/no-material.svg'
import StudyMaterialViewer from '../study-materials/StudyMaterialViewer'
import CustomTable from '../../common/custom-table/CustomTable'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'

const columns = [
    { field: "index", index: true, width: "100px", name: "Sl. no.", minWidth: "80px", rowPadding: "10px 20px", align: "center" },
    { field: "study_material_name", name: "Study Material", minWidth: "250px" },
    { field: "pub_date", width: "130px", renderCell: item => formatDate( item.study_material_published_date ), name: "Created on", minWidth: "120px" },
    { field: "subject", width: "200px", renderCell: item => item?.subject_name || "Not Available", name: "Subject", minWidth: "150px" },
    { field: "attachments_count", name: "Attachments", align: "center" },
    { field: "attachments_download_count", name: "Downloads", align: "center" },
]

const StudyMaterialDetails = ( { userData } ) => {

    const [error, setError] = useState( null )
    const [loading, setLoading] = useState( true )
    const [selectedMaterial, setSelectedMaterial] = useState( null )
    const [studyMaterialDetails, setStudyMaterialDetails] = useState( [] )

    const { empcode } = useParams()
    const [searchParams] = useSearchParams( { legacy: true } )
    const legacy = searchParams.get( 'legacy' ) === 'true'

    const loadMaterials = useCallback( async () => {
        setLoading( true )
        try {
            const { data: { data } } = await api.audit.getStudyMaterialsByFacultyId( empcode, { legacy } )
            setStudyMaterialDetails( data )
            setError( null )
        } catch ( err ) {
            console.log( err )
            setError( err?.response?.data?.message || "Something went wrong while fetching study materials details." )
        } finally {
            setLoading( false )
        }
    }, [empcode, legacy] )

    useEffect( () => {
        loadMaterials()
    }, [loadMaterials] )

    return (
        <Box maxHeight="350px" display="flex" flexDirection="column" overflow="hidden">

            {selectedMaterial && <StudyMaterialViewer studyMaterial={selectedMaterial} openState={Boolean( selectedMaterial )} handleClose={() => setSelectedMaterial( null )} />}


            {/* Data */}
            {!loading && !error && studyMaterialDetails.length > 0 && <CustomTable onRowClick={item => setSelectedMaterial( item )} data={studyMaterialDetails} columns={columns} />}

            {/* Loading */}
            {loading && !error && <Box padding="50px 20px" display="flex" justifyContent="center">
                <DataLoadingSpinner waitingMessage="Please wait! Loading materials..." />
            </Box>}

            {/* Error */}
            {error && <TryAgainMessageBlock getData={loadMaterials} loading={loading} err={error} />}

            {/* No Data */}
            {!loading && !error && studyMaterialDetails.length === 0 && <Box padding="20px" gap="20px" display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                <img src={noMaterialsImg} height="100px" alt="Something went wrong!" />
                <Typography variant="subtitle2"><em>{userData.employee_name}</em> hasn't created any study materials!</Typography>``
                <Button disabled={loading} onClick={loadMaterials} startIcon={Icons.default.Replay} variant="outlined" sx={{ textTransform: "capitalize" }} color="secondary">Fetch again</Button>
            </Box>}
        </Box>
    )
}

export default StudyMaterialDetails
